import React, {memo, useEffect} from 'react'
import {ACTIVITY_TYPE, AllActivityTypes} from "../../types-enums/activity";
import {CheckboxInput, Text} from 'atmosfair-ui';
import "./styles.css"
import {isActivityCarBusState, isActivityFlightState, isActivityHotelState} from "../../utils/check/type-guards";
import FlightRoute from "../../molecules/activity/string-display/flight-route/FlightRoute";
import HotelLocation from "../../molecules/activity/string-display/hotel-location/HotelLocation";
import {theme} from "../../styles/theme";
import {useTranslation} from "react-i18next";
import {getActivityShortTitleAndType, WhereToDisplayActivityString} from "../../utils/string/common";
import CarBusInformation from "../../molecules/activity/string-display/car-bus-information/CarBusInformation";

export interface TravelComponentAbbreviationProps {
    activity: AllActivityTypes,
    selectTravelComponent?: () => void,
    selected?: boolean,
    showReturnIcon: boolean,
}


const SelectableActivity = memo(function SelectableTravelComponent({
                                                                       activity,
                                                                       selectTravelComponent,
                                                                       selected,
                                                                       showReturnIcon,
                                                                   }: TravelComponentAbbreviationProps) {
    const {i18n} = useTranslation()
    const {common: {activityType}} = activity
    const {activityTypeString} = getActivityShortTitleAndType(activity, i18n)

    useEffect(() => {
        if (
            (typeof selected === 'undefined' && selectTravelComponent) ||
            (typeof selectTravelComponent === 'undefined' && selected)) throw new Error(
            "You cannot set selected to undefined and don't pass a selectTravelComponent function (or vice versa)."
        )
    }, []);

    const _renderActivityString = () => {
        const commonActivityProps = {
            iconColor: theme.colors.black,
            whereToDisplay: WhereToDisplayActivityString.travelComponents,
            truncatedWordsListMaxWidthPercentage: 80,
        }
        switch (activityType) {
            case ACTIVITY_TYPE.flight:
                if (isActivityFlightState(activity)) return <FlightRoute
                    showReturnIcon={showReturnIcon}
                    flight={activity}
                    {...commonActivityProps}/>
                break
            case ACTIVITY_TYPE.hotel:
                if (isActivityHotelState(activity)) return <HotelLocation
                    hotel={activity}
                    {...commonActivityProps}/>
                break
            case ACTIVITY_TYPE.car_bus:
                if (isActivityCarBusState(activity)) return <CarBusInformation
                    carBus={activity}
                    {...commonActivityProps} />
                break;
            default:
                return activityType satisfies never
        }
    }

    return <div className={"selectable-activity-container"}>
        <div className={"selectable-activity-checkbox-wrapper"}>
            {typeof selected !== "undefined" && selectTravelComponent && <CheckboxInput
                containerStyle={{height: "unset", minWidth: "unset"}}
                checked={selected}
                onChange={selectTravelComponent}
                label={"LABELS.TRAVEL_COMPONENTS.SELECT_TRAVEL_COMPONENT"}
                hideLabel={true}/>}
            {_renderActivityString()}
        </div>
        <Text>{activityTypeString}</Text>
    </div>
})

export default SelectableActivity